import "./hierarchyControllers.less";

import { IComponentController, IComponentOptions, material } from "angular";
import * as moment from "moment";

import { Constant } from "../common/utils/constants";
import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";

export const HIERARCHY_CONTROLLERS_COMPONENT: string = "hierarchyControllersComponent";
class HierarchyControllersCtrl implements IComponentController {

    private downloadBtnLbl: string = "Download selected";
    private uploadBtnLbl: string = "Upload";
    private moveBtnLbl: string = "Move selected";
    private createFolderLbl: string = "Create Folder";
    private deleteBtnLbl: string = "Delete selected";
    private duplicateBtnLbl: string = "Copy selected";
    private renameBtnLbl: string = "Rename selected";
    private isRowSelected: number;
    private input: HTMLElement = document.getElementById("#fileInput");

    static $inject = [HIERARCHY_SERVICE, "$mdDialog", "$mdToast", "$scope"];
    constructor(private hierarchyService: HierarchyService,
        private $mdDialog: ng.material.IDialogService,
        private $mdToast: ng.material.IToastService,
        private $scope: ng.IScope) {
        var _self_: HierarchyControllersCtrl = this;
        this.hierarchyService.rowSelected.subscribe((value:number) => {
            $scope.$evalAsync(()=> _self_.isRowSelected = value);
        });
        this.initializeUploadButtonSettings();
    }

    private operationCompleted(message: string): void {
        this.hierarchyService.showToast(message === ""? Constant.SUCCESS: message);
        this.hierarchyService.resetSelectedRows();
        this.hierarchyService.stoppingAsyncOperation();
    }

    private move(): void {
        if (!this.isRowSelected) {
            this.hierarchyService.showToast(Constant.TOAST_SELECT_BEFORE_ACTION);
        } else {
            this.hierarchyService.showMoveModal();
        }
    }

    private download(): void {
        if (!this.isRowSelected) {
            this.hierarchyService.showToast(Constant.TOAST_SELECT_BEFORE_ACTION);
        } else {
            var _self_: HierarchyControllersCtrl = this;
            var askFilename : ng.material.IPromptDialog = this.$mdDialog.prompt()
                .title(Constant.DOWNLOAD_NAME_TITLE)
                .initialValue(Constant.CAPSULE + moment().format(Constant.DATE_FORMAT))
                .required(true)
                .ok(Constant.DOWNLOAD)
                .cancel(Constant.CANCEL);
            this.$mdDialog.show(askFilename)
            .then(function(fileName:string):void {
                _self_.hierarchyService.showToast(Constant.DOWNLOAD_STARTED);
                _self_.hierarchyService.$downloadCapsule(fileName);
            }, function(fileName:string):void {
                _self_.hierarchyService.showToast(Constant.DOWNLOAD_ABORTED);
            });
        }
    }
    private createFolder(): void {
        var _self_: HierarchyControllersCtrl = this;
        var askFolderName : ng.material.IPromptDialog = this.$mdDialog.prompt()
            .title(Constant.CREATE_FOLDER_TITLE)
            .initialValue(Constant.NEW_FOLDER + moment().format(Constant.DATE_FORMAT))
            .required(true)
            .ok(Constant.OK)
            .cancel(Constant.CANCEL);
        this.$mdDialog.show(askFolderName)
        .then(function(folderName:string):void {
            _self_.hierarchyService.$createFolder(_self_.hierarchyService.lastSelectedFolder.relativePath, folderName)
                .subscribe(
                    (result) =>_self_.operationCompleted(Constant.$SUCCESS),
                    (error) => _self_.operationCompleted(error.data.message));
        }, function():void {
            this.hierarchyService.showToast(Constant.FOLDER_CREATION_ABORTED);
        });
    }

    private duplicate(): void {
        if (!this.isRowSelected) {
            this.hierarchyService.showToast(Constant.TOAST_SELECT_BEFORE_ACTION);
        } else {
            this.hierarchyService.showDuplicateModal();
        }
    }

    private rename(): void {
        if (this.isRowSelected !== 1) {
            this.hierarchyService.showToast(Constant.TOAST_ERROR_RENAME);
        } else {
            var _self_: HierarchyControllersCtrl = this;
            var askFilename : ng.material.IPromptDialog = this.$mdDialog.prompt()
                .title(Constant.RENAME_NAME_TITLE)
                .required(true)
                .ok(Constant.RENAME)
                .cancel(Constant.CANCEL);
            this.$mdDialog.show(askFilename)
            .then(function(newName:string):void {
                _self_.hierarchyService.$rename(newName)
                .subscribe((result) => {
                _self_.operationCompleted(Constant.$SUCCESS);},
                (error) => {
                    _self_.operationCompleted(error.data.message);
                });
            }, function(fileName:string):void {
                _self_.hierarchyService.showToast(Constant.RENAMING_ABORTED);
            });
        }
    }

    private delete(): void {
        if (!this.isRowSelected) {
            this.hierarchyService.showToast(Constant.TOAST_SELECT_BEFORE_ACTION);
        } else {
            var _self_: HierarchyControllersCtrl = this;
            var askForDeletion : ng.material.IConfirmDialog = this.$mdDialog.confirm()
                .title(Constant.DELETION_CONFERMATION_MESSAGE)
                    .ok(Constant.YES)
                    .cancel(Constant.NO);
            this.$mdDialog.show(askForDeletion).then(function():void {
                _self_.hierarchyService.$delete()
                .subscribe((result) =>
                _self_.operationCompleted(Constant.$SUCCESS),
                (error) => _self_.operationCompleted(error));
            }, function():void {
                this.hierarchyService.showToast(Constant.DELETION_ABORTED);
            });
        }
    }

    private initializeUploadButtonSettings(): void {
        var _self_: HierarchyControllersCtrl = this;
        document.getElementById("fileInput").addEventListener("change", function (evt: any): void {
            if (evt.target.files.length > 0) {
            _self_.hierarchyService.$uploadCapsule(evt.target.files[0]).subscribe(
                result => {
                    $("#fileInput").prop("value", "");
                    _self_.operationCompleted(Constant.$SUCCESS);
                },
                error => {
                    if (error.status === 409) {
                        var ask: material.IConfirmDialog = _self_.$mdDialog.confirm()
                            .title("File already exists!")
                            .textContent("The file you are trying to upload already exists. Would you like to overwrite it?")
                            .ok(Constant.YES)
                            .cancel(Constant.NO);
                        _self_.$mdDialog.show(ask).then(function (): void {
                            _self_.hierarchyService.$uploadCapsule(evt.target.files[0], true)
                                .subscribe((result) => {
                                    _self_.operationCompleted(Constant.$SUCCESS);
                                    $("#fileInput").prop("value", "");
                                }, (error) => {
                                    _self_.operationCompleted(error.data.message);
                                    $("#fileInput").prop("value", "");
                                });
                        }, function (): void {
                            _self_.hierarchyService.$uploadCapsule(evt.target.files[0], false)
                            .subscribe((result) => {
                                _self_.operationCompleted(Constant.$SUCCESS);
                                $("#fileInput").prop("value", "");
                            }, (error) => {
                                _self_.operationCompleted(error.data.message);
                                $("#fileInput").prop("value", "");
                            });
                        });
                    } else {
                        _self_.operationCompleted(error.data.message);
                        $("#fileInput").prop("value", "");
                    }
                }
            );
        }
        });
        $("#fileInput").prop("value", "");
    }

    private upload(): void {
        $("#fileInput").click();
    }
}

export const hierarchyControllersComponent: IComponentOptions = {
    controller: HierarchyControllersCtrl,
    template: require("./hierarchyControllers.html"),
    bindings: {}
};



// WEBPACK FOOTER //
// ./app/hierarchy-controllers/hierarchyControllers.component.ts